//import * as moment from 'moment';
//import 'moment-timezone';



import {ISchedule, IScheduleAllData} from "../schedule/ScheduleTypes";

interface IMediaStreamScheduleAllData extends IScheduleAllData{
    schedule: MediaStreamScheduleData;
    tags: string[]
}

interface MediaStreamScheduleData extends ISchedule {
    scheduleId: number;
    mediaId: number;
    startUtc: number;
    endUtc: number;
    interval: number | null;
    intervalType: MediaStreamScheduleIntervalType | null;
    scheduleType: string;
    mediaTitle: string | null;
    mediaDescShort: string | null;
    mediaOverrideDescShort: boolean;
    mediaOverrideTags: boolean;
    updated: number;
}

// interface MediaStreamScheduleTagData {
//     tag: string;
// }

// interface MediaStreamSchedulesCreateReq {
//     data: IMediaStreamScheduleAllData;
// }
//
// interface MediaStreamSchedulesUpdateReq {
//     data: IMediaStreamScheduleAllData;
// }

interface IMediaStreamSchedulesSyncReq {
    schedulesAll: IMediaStreamScheduleAllData[];
}

interface IMediaStreamSchedulesSyncResult {
    schedulesAll: IMediaStreamScheduleAllData[];
}

enum MediaStreamScheduleType{
    Record = "record",
    View = "view"
}

enum MediaStreamScheduleIntervalType {
    Day = "d",
    Week = "w",
    Month = "m",
    Year = "y"
}

export {
    IMediaStreamScheduleAllData,
    MediaStreamScheduleData,
    MediaStreamScheduleIntervalType,
    IMediaStreamSchedulesSyncReq,
    IMediaStreamSchedulesSyncResult,
    MediaStreamScheduleType
}